import { useState } from 'react'

const useApi = () => {
  const [bearerToken, setBearerToken] = useState<string>('')
  const [xAgency, setXAgency] = useState<string>('')

  const apiPath = process.env.REACT_APP_PP_API_URL
  console.log('API Path:', apiPath)

  const makeRequest = async (url: string, method: string = 'POST', body: object | null = null) => {
    const fullUrl = apiPath + '/' + url

    const options: RequestInit = {
      method: method,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
        'X-Prospector-Agency': xAgency,
      },
    }

    if (body && method !== 'GET' && method !== 'HEAD') {
      options.body = JSON.stringify(body)
    }

    const response = await fetch(fullUrl, options)

    if (!response.ok && response.status !== 404) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return response.json()
  }

  const createSessionRequest = async (crmKey: string, endpoint: string, crmUrl: string, destination: string) => {
    if (!crmUrl) {
      throw new Error('Invalid crmUrl: crmUrl cannot be empty');
    }
    const linkedCrmKey = crmUrl.split('/').pop();
    return makeRequest('leads/quick-call', 'POST', {
      crm_key: crmKey,
      endpoint: endpoint,
      module: 'STREET',
      linked_crm_key: linkedCrmKey,
      telephone: destination,
      crm_url: crmUrl
    })
  }

  return {
    makeRequest,
    setBearerToken,
    bearerToken,
    setXAgency,
    createSessionRequest,
  }
}

export default useApi
